import * as BulkCaseActions from './action';
const initialState = {
    uploadListSuccess: [],
    uploadListFailure: [],
    downloadTemplateSuccess: [],
    downloadTemplateFailure: [],
    uploadBulkSuccess: [],
    uploadBulkFailure: [],
    downloadFileSuccess: [],
    downloadFileFailure: []
}
const bulkCaseReducer = (state = initialState, action) => {
    switch (action.type) {
        case BulkCaseActions.FETCH_PREVIOUS_UPLOAD_LIST_SUCCESS:
            return state = {
                ...state,
                uploadListSuccess: action.data
            }
        case BulkCaseActions.FETCH_PREVIOUS_UPLOAD_LIST_FAILURE:
            return state = {
                ...state,
                uploadListFailure: action.data
            }
        case BulkCaseActions.DOWNLOAD_BULK_CASE_TEMPLATE_SUCCESS:
            return state = {
                ...state,
                downloadTemplateSuccess: action.data
            }
        case BulkCaseActions.DOWNLOAD_BULK_CASE_TEMPLATE_FAILURE:
            return state = {
                ...state,
                downloadTemplateFailure: action.data
            }   
        case BulkCaseActions.UPLOAD_BULK_CASES_SUCCESS:
            return state = {
                ...state,
                uploadBulkSuccess: action.data
            }
        case BulkCaseActions.UPLOAD_BULK_CASES_FAILURE:
            return state = {
                ...state,
                uploadBulkFailure: action.data
            }   
        case BulkCaseActions.DOWNLOAD_BULK_CASES_FILE_SUCCESS:
            return state = {
                ...state,
                downloadFileSuccess: action.data
            }
        case BulkCaseActions.DOWNLOAD_BULK_CASES_FILE_FAILURE:
            return state = {
                ...state,
                downloadFileFailure: action.data
            }
        default: return state
    }
};

export default bulkCaseReducer;
